import "./OrdersHeader.css";
import { MdRefresh, MdFileDownload } from "react-icons/md";

function OrdersHeader({ onRefresh }) {
  return (
    <div className="orders-header">

      <div className="orders-header-left">
        <h1>📦 Order Management</h1>
        <p>Manage incoming customer orders</p>
      </div>

      <div className="orders-header-right">

        <button
          className="refresh-btn"
          onClick={onRefresh}
        >
          <MdRefresh />
          Refresh
        </button>

        <button
          className="export-btn"
        >
          <MdFileDownload />
          Export
        </button>

      </div>

    </div>
  );
}

export default OrdersHeader;